import { Slide, Zoom } from 'react-reveal';
import '../../App.css'
import styled from 'styled-components';
import workshop_Img1 from '../../assets/img/workshop/How-to-Build-A-startup.png'
import workshop_Img2 from '../../assets/img/workshop/Startup-Entrepreneurship-Culture.png'
import workshop_Img3 from '../../assets/img/workshop/Design-thinking.png'
import workshop_Img4 from '../../assets/img/workshop/creation-commercialization.png'
import workshop_Img5 from '../../assets/img/workshop/E-commerce-Build-Up.png'
import '../../App.css'
import { Link } from 'react-router-dom';
// import workshop_Img6 from '../../assets/img/How-to-Build-A-startup.png'
function Workshop2() {
    const image = 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTF8fGNvbXB1dGVyfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60'
    return (
        <Container className='container'>
            <Zoom>

                <h2 className='text-center'>Learn More About Startups & Entrepreneurship</h2>
                <MainParagraph>Converting an idea from scratch into reality is never an easy job.  Join our Entrepreneurial Workshop Sessions to discover what's important to your personal and professional career.</MainParagraph>
            </Zoom>

            <GridContainer>
                <Slide up>
                    <Link to='/workshopDetail' >
                        <div className="workshop">
                            <img src={workshop_Img1} alt="" />
                            <h3 className='my-2 mx-2'>How to Build A startup? Startup Buildup</h3>
                        </div>
                    </Link>

                    <Link to='/workshopDetail2' >
                        <div className="workshop">
                            <img src={workshop_Img2} alt="" />
                            <h3 className='my-2  mx-2'>Startups & Entrepreneurship Culture</h3>
                        </div>
                    </Link>


                    <Link to='/workshopDetail3' >
                        <div className="workshop">
                            <img src={workshop_Img4} alt="" />
                            <h3 className='my-2 mx-2'>Creation & Commercialization</h3>
                        </div>
                    </Link>

                    <Link to='/workshopDetail4' >
                        <div className="workshop">
                            <img src={workshop_Img3} alt="" />
                            <h3 className='my-2 mx-2'>Design Thinking Sessions</h3>
                        </div>
                    </Link>

                    <Link to='/workshopDetail5' >
                        <div className="workshop">
                            <img src={workshop_Img5} alt="" />
                            <h3 className='my-2  mx-2'>E-commerce Buildup</h3>
                        </div>
                    </Link>
                </Slide>

            </GridContainer>
        </Container>
    )
}

export default Workshop2

const Container = styled.div` 
margin-top:50px ;
            h1{
                font-weight:bold ;
            }

            img{
                width: 100%;
                height:200px;
                object-fit:cover;
                
            }
            img:hover{
                transform:scale(0.95)
            }

div{
    .workshop{
        box-shadow: rgba(100, 100, 111, 0.3) 0px 7px 29px 0px;
        border-radius:10px;
        transition:all 0.5s ;
    }
    .workshop:hover{
  
        transform:rotateZ(5deg)
    }

}

`
const Heading = styled.h1` 
text-align:center ;
width:35rem;
margin: auto;
color:#FA7525 ;
    

        @media (max-width:590px){
            width:100%;
        }
`
const GridContainer = styled.div` 
display:grid ;
grid-gap:20px ;
grid-template-columns:repeat(auto-fit,minmax(300px, 1fr)) ;
justify-content:center;



            h1{
                font-size:25px ;
                margin-top:20px ;
                color:black ;
            }

                div{
                    padding:15px ;
                    box-sizing: border-box;
                    margin-top:20px ;
                }
`
const MainParagraph = styled.p` 
/* width:30rem ; */
margin:auto ;
margin-top:20px ;
text-align:center ;
font-size:1.3rem ;
`